import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import clsx from "clsx";
import { Grid } from "./Grid";
import { IconButton } from "./IconButton";
import { Stack } from "./Stack";
import { DragIndicatorOutline } from "../icons/icons";
import { mergeSx } from "../system";
import { Draggable } from "@hello-pangea/dnd";
import { SlotsProvider } from "../providers/SlotsProvider";
export const draggableListItemClasses = {
    root: "MinervaDraggableListItem-root",
    dragging: "MinervaDraggableListItem-dragging",
};
export const draggableListItemSlots = {
    iconButton: IconButton,
    icon: DragIndicatorOutline,
    container: Grid,
};
/**
 * DraggableListItem can be dragged around and dropped onto DroppableColumns. A DraggableListItem must always be contained within a DroppableColumn. It is possible to reorder a DraggableListItem within his home DroppableColumn or move to another DroppableColumn.
 */
export const DraggableListItem = (props) => {
    const { draggableId, index, disableDrag, children, configuration, startNode, slots, slotProps, sx, className, ...rest } = props;
    const configurationWithDefaults = {
        alwaysShowDragHandle: false,
        showDragHandleStrategy: "display",
        ...configuration,
    };
    return (_jsx(Draggable, { draggableId: draggableId, index: index, isDragDisabled: disableDrag, children: (provided, snapshot) => (_jsx(SlotsProvider, { baseSlots: draggableListItemSlots, slots: slots, children: ({ iconButton: IconButton, icon: Icon, container: Container }) => (_jsxs(Stack, { ...provided.draggableProps, ref: provided.innerRef, width: "100%", sx: mergeSx({
                    borderRadius: (theme) => theme.radius.default,
                    [`&.${draggableListItemClasses.dragging}`]: {
                        border: "1px solid",
                        borderColor: (theme) => theme.palette.outline,
                        boxShadow: (theme) => theme.shadows.allAround,
                    },
                    "&:hover .drag-handle": {
                        opacity: 1,
                        display: "inherit",
                    },
                }, sx), className: clsx([
                    className,
                    draggableListItemClasses.root,
                    snapshot.isDragging && draggableListItemClasses.dragging,
                ]), ...rest, children: [startNode && _jsx(Stack, { width: "100%", children: startNode }), _jsxs(Container, { container: true, alignItems: "center", gap: 2, sx: {
                            padding: 1,
                            ...slotProps?.container?.sx,
                        }, ...slotProps?.container, children: [_jsx(IconButton, { ...slotProps?.iconButton, variant: "minimal", ...provided.dragHandleProps, className: "drag-handle", sx: mergeSx({
                                    transition: "opacity 0.2s",
                                    opacity: configurationWithDefaults.showDragHandleStrategy ===
                                        "opacity"
                                        ? configurationWithDefaults.alwaysShowDragHandle
                                            ? 1
                                            : snapshot.isDragging
                                                ? 1
                                                : 0
                                        : undefined,
                                    display: configurationWithDefaults.showDragHandleStrategy ===
                                        "display"
                                        ? configurationWithDefaults.alwaysShowDragHandle
                                            ? "inherit"
                                            : snapshot.isDragging
                                                ? "inherit"
                                                : "none"
                                        : undefined,
                                }, slotProps?.iconButton?.sx), children: _jsx(Icon, { size: "xs", ...slotProps?.icon }) }), _jsx(Grid, { item: true, xs: true, minWidth: 0, children: children })] })] })) })) }));
};
//# sourceMappingURL=DraggableListItem.js.map